// https://reactrouter.com/docs/en/v6/getting-started/faq#what-happened-to-withrouter-i-need-it
// With a little different strcture than the example to keep same strucure, e.g. match.params

import React from 'react';
import {
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    // Create a simple mock of old history API, so we do not need to update all components
    const history = {
      push: (...args) => {
        navigate(...args);
      },
      replace: (...args) => {
        navigate(...args, {
          replace: true
        });
      }
    };

    return (
      <Component
        location={location}
        navigate={navigate}
        history={history}
        match={{
          params: params
        }}
        {...props}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default withRouter;
